/**
 * Покрытие пола комнаты на 2D-чертеже — точка входа раздела «Пол».
 *
 * Получает комнату и «сухую» запись слоя (что пользователь поменял), итоговый вид
 * собирает через каталог (`floorLook`) и отдаёт нужной укладке: плитка — TileFloor,
 * кварцвинил — QuartzVinylFloor. Комната без покрытия — просто светлая заливка.
 */
import type { RoomFloor } from "@/shared/plan";
import { floorLook } from "@/shared/catalog";
import type { Room } from "@/widgets/plan";
import { FloorPattern2D } from "./FloorPattern2D";

/** Комната без покрытия: пол ещё не назначен */
const BARE_FLOOR_COLOR = "#fbfcfe";

interface Props {
	room: Room;
	/** Запись слоя полов; нет — покрытие не назначено */
	floor?: RoomFloor;
}

export const FloorShape = ({ room, floor }: Props) => {
	if (!floor) {
		return (
			<polygon
				points={room.inner.map((p) => `${p.x},${p.y}`).join(" ")}
				fill={BARE_FLOOR_COLOR}
				stroke="rgba(0,0,0,0.04)"
				strokeWidth={1}
				style={{ pointerEvents: "auto" }}
			/>
		);
	}

	const look = floorLook(floor);
	return <FloorPattern2D room={room} look={look} />;
};
